import { createApp } from 'vue'
import App from './App.vue'
import {initRouter} from './router/index'
import { Carousel,Image  } from 'ant-design-vue';
import BaiduMap from '../node_modules/vue-baidu-map-3x'
import ElementPlus  from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import store  from './store';
const app = createApp(App)
app.use(BaiduMap,{
    ak:'63X4GKSoTuPgmjvx2t8me6Kz2hhgzvRZ'
})
app.use(ElementPlus , {
    locale: zhCn,
  })
app.use(Carousel).use(Image).use(store)
initRouter(app)
app.mount('#app')
